// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZWgz","left":"styles_left__2E3Q5","desktopActions":"styles_desktopActions__38EaP","title":"styles_title__3gAFr"};